<template>
  <div id="app" class="app">
    <div class="cover" v-if="isIE">请使用非ie内核浏览器访问本网站</div>
    <div v-if="!isIE">
      <div>
        <heads v-if="isRouterAlive"></heads>
        <div
          class="taps_outer"
          v-if="!($route.path=='/login'||$route.path=='/my'|| $route.path=='/ad' || $route.path=='/mailverify'|| $route.path=='/forgetPassword')"
        >
          <div class="taps_wrap">
            <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true" class="tab">
              <el-tab-pane
                :label="value.name"
                v-for="(value,index) in data"
                :key="index"
                :name="value.id.toString()"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <router-view />
      <buttons></buttons>
    </div>
  </div>
</template>

<script>
import Buttons from "./components/buttons";
import Heads from "./components/heads";
import Http from "./https";
export default {
  name: "App",
  components: { Heads, Buttons },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      activeName: "0",
      data: [],
      activeIndex: "0",
      weiz: 0,
      newsdata: "",
      newsdatainfo: "",
      newsSwitch: true,
      pagedata: "" //分页信息
    };
  },
  created() {
    if (this.IEVersion() == -1) {
      this.isIE = false;
    } else {
      this.isIE = true;
    }

    Http.fetchPost("index/head")
      .then(data => {
        let result = data.data;
        // console.log("daata:",result)
        if (result.code == 1) {
          // result.data.unshift({ id: 0, name: "首页", title: "", content: "" });
          this.data = result.data;
          this.data.splice(3, 0, {
            id: 11,
            name: "地方动态",
            title: "",
            content: ""
          });
          this.data.pop();
          this.data.pop();
          this.data.pop();
          this.data.pop();
        } else {
          this.$message.error(result.msg);
        }
      })
      .catch(err => {
        this.$message.error("服务器繁忙");
        return;
      });
  },
  methods: {
    IEVersion() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6; //IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; //edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1; //不是ie浏览器
      }
    },
    reload() {
      console.log("刷新了");
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    handleSelect(index, indexPath) {
      // console.log("index:", index);
      // console.log("indexPath:", indexPath);
    },
    handleClick(tab, event) {
      console.log('变换')
      let name = tab.name;
      let id = name.split("_")[1];
      console.log(tab.label)
      if(tab.label=='办事大厅'){
        this.$router.push({ path: "/investment" });
      }

      // console.log("index:", id);

      // console.log(tab, event);
    },
    //获取新闻
    getnews(page) {
      this.$ajax({
        method: "post",
        url: this.$api + "home/lists",
        data: {
          type: this.activeName,
          page
        }
      }).then(response => {
        let data = response.data;
        if (data.code == 1) {
          this.newsdata = data.data.data;
          this.pagedata = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    redirect(data) {
      alert(data);
      this.activeName = data;
    },
    getnewsInfo(id) {
      this.newsSwitch = false;
      this.$ajax({
        method: "post",
        url: this.$api + "home/details",
        data: {
          id
        }
      }).then(response => {
        let data = response.data;
        if (data.code == 1) {
          this.newsdatainfo = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    close() {
      this.newsSwitch = true;
    }
  },
  watch: {
    activeName(val) {
      switch (val) {
        case "0":
          this.$router.push({ path: "/home" });
          break;
        case "1":
          this.$router.push({ path: "/news", query: { type: 1 } });
          break;
        case "2":
          this.$router.push({ path: "/policy", query: { type: 2 } });
          break;
        // case "5":
        //   this.$router.push({ path: "/investment" });
        //   break;
        case "6":
          this.$router.push({ path: "/announcement", query: { type: 6 } });
          break;
        case "7":
          this.$router.push({ path: "/case", query: { type: 7 } });
          break;
        case "8":
          this.$router.push({ path: "/recruit", query: { type: 8 } });
          break;
        case "9":
          this.$router.push({ path: "/download" });
          break;
        case "10":
          this.$router.push({ path: "/credit", query: { type: 10 } });
          break;
        case "11":
          this.$router.push({ path: "/credit2", query: { type: 11 } });
          break;
      }
    },
    $route(val) {
      switch (val.path) {
        case "/home":
          this.activeName = "0";
          break;
        case "/news":
          this.activeName = "1";
          break;
        case "/policy":
          this.activeName = "2";
          break;
        case "/investment":
          this.activeName = "5";
          break;
        case "/investment/:id/:one":
          this.activeName = "5";
          break;
        case "/announcement":
          this.activeName = "6";
          break;
        case "/case":
          this.activeName = "7";
          break;
        case "/recruit":
          this.activeName = "8";
          break;
        case "/download":
          this.activeName = "9";
          break;
        case "/credit":
          this.activeName = "10";
          break;
      }

      switch (val.query.type) {
        case "1":
          this.activeName = "1";
          break;
        case "2":
          this.activeName = "2";
          break;
        case "6":
          this.activeName = "6";
          break;
        case "7":
          this.activeName = "7";
          break;
        case "9":
          this.activeName = "9";
          break;
        case "10":
          this.activeName = "10";
          break;
      }
    }
  }
};
</script>

<style>
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
* {
  padding: 0;
  margin: 0;
}
.omit {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /*align-items: center;*/
}
.el-tabs__nav-wrap::after {
  height: 0px;
}

a {
  text-decoration: none;
}
div {
  box-sizing: border-box;
}
</style>
<style>
.taps_outer .el-tabs__item {
  color: #ffffff;
  background: linear-gradient(
    180deg,
    rgba(30, 215, 245, 1) 0%,
    rgba(6, 154, 215, 1) 100%
  );
  float: left;
  /*border-radius: 4px;*/
  margin: 20px 0 30px 0;
}
.taps_outer .el-tabs__item.is-active {
  background: linear-gradient(
    180deg,
    rgba(11, 174, 234, 1) 0%,
    rgba(1, 103, 176, 1) 100%
  );
  color: #ffffff;
}
.taps_outer .el-tabs__nav-wrap {
  position: static;
}
.taps_outer .el-tabs__nav.is-stretch {
  min-width: 1064px;
  /*display: none;*/
}
.taps_outer .el-tabs__header {
  position: static;
  background: #fff;
  margin: 0;
}

.taps_outer .tab .el-tabs__nav-wrap {
  display: flex;
  justify-content: center;
  padding: 0;
  background: #fff;
  margin: 0;
}
.taps_outer .el-tabs__active-bar {
  display: none;
}
.taps_outer #tab-5 {
  border-radius: 4px 0px 0px 4px;
  padding-left: 20px;
}
.taps_outer #tab-10 {
  border-radius: 0px 4px 4px 0px;
  padding-right: 20px;
}
.taps_outer .el-tabs__nav-wrap:after {
  background-color: transparent;
}
.app .el-tabs__nav-prev,
.app .el-tabs__nav-next {
  display: none;
}
</style>
<style scoped>
.index {
  width: 100%;
}
.el-tabs__nav is-top {
  /*color:red;*/
  color: white !important;
}
/* .tab { */
/*display: flex;*/
/*justify-content: center;*/
/* } */
.taps_outer {
  background: #f7f8fc;
}
.taps_wrap {
  width: 100%;
  margin: 0 auto;
}
.cover {
  text-align: left;
  padding: 3px;
  padding-left: 9px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue